import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "./context/AuthContext";
import { NotificationProvider } from "./context/NotificationContext";
import { ThemeProvider } from "./context/ThemeContext";
import { TranslationProvider } from "./context/TranslationContext";
import ToastContainer from "./components/base/Toast";
import RouteClassApplier from "./components/base/RouteClassApplier";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider>
        <TranslationProvider>
        <AuthProvider>
          <NotificationProvider>
            <BrowserRouter basename={__BASE_PATH__}>
              <RouteClassApplier />
              <AppRoutes />
              <ToastContainer />
            </BrowserRouter>
          </NotificationProvider>
        </AuthProvider>
        </TranslationProvider>
      </ThemeProvider>
    </I18nextProvider>
  );
}

export default App;
